import React from 'react';
import ReactPaginate from 'react-paginate';

interface TableGen2Props {
  dataTableGen: {
    data: any[];
    columns: { nameColumn: string; classThHead?: string }[];
    isAction: boolean;
    actionIcon: { action: string; icon: JSX.Element }[];
    classTable?: string;
    divContent?: string;
    classTrBody?: string;
    iconClass?: string;
    totalPages: number;
  };
  handleNextPageClick: (selectedItem: { selected: number }) => void;
  onAction: (data: { action: string; id?: string; data: any }) => void;
}

export const TableGen2: React.FC<TableGen2Props> = (props) => {
  const { dataTableGen, handleNextPageClick, onAction } = props;

  const getAllpaginate = (valueTotal: number) => {
    return valueTotal > 1 ? true : false;
  };

  return (
    <>
      <div className={`${dataTableGen.data.length <= 0 ? '' : dataTableGen?.divContent}`}>
        <table id="table-content-2" className={dataTableGen?.classTable}>
          <thead>
            <tr className={``}>
              {dataTableGen.columns.map((column: any, index: number) => (
                <th key={index} className={`py-2  ${column?.classThHead}`}>
                  {column?.nameColumn}
                </th>
              ))}
              {dataTableGen.isAction &&
                dataTableGen.data.length > 0 &&
                dataTableGen.actionIcon.map((icon, index) => (
                  <th key={icon.action + index} className="p-3 w-4 bg-[#f9fafb]">
                    {' '}
                  </th>
                ))}
            </tr>
          </thead>
          <tbody>
            {dataTableGen.data.length > 0 &&
              dataTableGen.data.map((row: any, index: number) => (
                <tr key={index} className={dataTableGen?.classTrBody}>
                  {dataTableGen.columns.map((columnMap: any, index: number) => (
                    <td
                      key={columnMap?.keysColumns + index}
                      className={`${columnMap?.classStyles}`}
                    >
                      {row[columnMap?.keysColumns]}
                    </td>
                  ))}
                  {dataTableGen.isAction &&
                    dataTableGen.actionIcon.map((itemIcon: any, index: any) => (
                      <td
                        key={itemIcon.action + index}
                        className={`p-4 w-4 ${dataTableGen.iconClass}`}
                        onClick={() =>
                          onAction(
                            itemIcon.action === 'edit'
                              ? { action: itemIcon.action, id: row.id, data: row }
                              : { action: itemIcon.action, data: row }
                          )
                        }
                      >
                        {itemIcon.icon}
                      </td>
                    ))}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      {dataTableGen.data.length <= 0 && (
        <div className="bg-green-100 border border-green-400  px-4 py-3 rounded relative" role="alert">
          <span className="block sm:inline">Not search results found</span>
        </div>
      )}
      <div className='w-full'>
        {getAllpaginate(dataTableGen.totalPages) && (
          <ReactPaginate
            breakLabel="..."
            nextLabel={'Next'}
            onPageChange={handleNextPageClick}
            pageRangeDisplayed={5}
            pageCount={dataTableGen.totalPages}
            previousLabel={'Previous'}
            renderOnZeroPageCount={null}
            pageClassName="page-item fontPageTitle"
            pageLinkClassName="page-link"
            previousClassName="mt-6 fontPageTitle w-full text-start"
            previousLinkClassName="page-link"
            nextClassName="mt-6 fontPageTitle  w-full text-end"
            nextLinkClassName="page-link"
            breakClassName="page-item fontPageTitle"
            breakLinkClassName="page-link"
            containerClassName="flex justify-center pagination"
            activeClassName="bg-[#005FF9] text-white"
          />
        )}
      </div>
    </>
  );
};